import { call, put, takeLatest, delay } from 'redux-saga/effects';

import { CLIENTS_EDIT } from 'src/store/ActionTypes';
import * as api from 'src/store/api';

function* fetchOnboardingConfigsL1(action) {
  try {
    const configs = yield call(api.fetchOnboardingConfigs, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1_SUCCEEDED,
      payload: configs,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1_FAILED,
      payload: e.message,
    });
  }
}

function* fetchOnboardingConfigsL2(action) {
  try {
    const configs = yield call(api.fetchOnboardingConfigs, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2_SUCCEEDED,
      payload: configs,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2_FAILED,
      payload: e.message,
    });
  }
}

function* fetchOnboardingConfigsL3(action) {
  try {
    const configs = yield call(api.fetchOnboardingConfigs, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3_SUCCEEDED,
      payload: configs,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3_FAILED,
      payload: e.message,
    });
  }
}

function* fetchOnboardingConfigTypes(action) {
  try {
    const configTypes = yield call(api.fetchOnboardingConfigTypes, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES_SUCCEEDED,
      payload: configTypes,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES_FAILED,
      payload: e.message,
    });
  }
}

function* fetchClientOnboardingConfig(action) {
  try {
    const { type, scopeClientType, tenant } = action.payload;
    const config = yield call(api.fetchClientOnboardingConfig, type, scopeClientType, tenant);
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG_SUCCEEDED,
      payload: config,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG_FAILED,
      payload: e.message,
    });
  }
}

function* fetchClient(action) {
  try {
    const client = yield call(api.getClient, action.payload);
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_SUCCEEDED,
      payload: client,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.FETCH_CLIENT_FAILED,
      payload: e.message,
    });
  }
}

function* enableRealTimeApi(action) {
  try {
    yield call(api.enableRealTimeApi, action.payload);
    yield put({
      type: CLIENTS_EDIT.ENABLE_REAL_TIME_API_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.ENABLE_REAL_TIME_API_FAILED,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'enableRealTimeApiStatus',
    });
  }
}

function* disableRealTimeApi(action) {
  try {
    yield call(api.disableRealTimeApi, action.payload);
    yield put({
      type: CLIENTS_EDIT.DISABLE_REAL_TIME_API_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.DISABLE_REAL_TIME_API_FAILED,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'disableRealTimeApiStatus',
    });
  }
}

function* editClient(action) {
  try {
    const { clientId, client } = action.payload;
    yield call(api.editClient, clientId, client);
    yield put({
      type: CLIENTS_EDIT.EDIT_CLIENT_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.EDIT_CLIENT_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'editClientStatus',
    });
  }
}

function* editOnboardingConfig(action) {
  try {
    const { id, onboardingConfig } = action.payload;
    yield call(api.updateOnboardingConfig, id, onboardingConfig);
    yield put({
      type: CLIENTS_EDIT.EDIT_ONB_CONFIG_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.EDIT_ONB_CONFIG_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'editOnboardingConfigStatus',
    });
  }
}

function* addOnboardingConfig(action) {
  try {
    yield call(api.addOnboardingConfig, action.payload);
    yield put({
      type: CLIENTS_EDIT.ADD_ONB_CONFIG_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: CLIENTS_EDIT.ADD_ONB_CONFIG_FAILED,
      payload: e.message,
    });
  } finally {
    delay(500);
    yield put({
      type: CLIENTS_EDIT.UNSET,
      payload: 'addOnboardingConfigStatus',
    });
  }
}

function* fetchOnboardingConfigsL1Saga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIGS_L1, fetchOnboardingConfigsL1);
}

function* fetchOnboardingConfigsL2Saga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIGS_L2, fetchOnboardingConfigsL2);
}

function* fetchOnboardingConfigsL3Saga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIGS_L3, fetchOnboardingConfigsL3);
}

function* fetchOnboardingConfigTypesSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_ONB_CONFIG_TYPES, fetchOnboardingConfigTypes);
}

function* fetchClientOnboardingConfigSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_CLIENT_ONB_CONFIG, fetchClientOnboardingConfig);
}

function* fetchClientSaga() {
  yield takeLatest(CLIENTS_EDIT.FETCH_CLIENT, fetchClient);
}

function* editClientSaga() {
  yield takeLatest(CLIENTS_EDIT.EDIT_CLIENT, editClient);
}

function* editOnboardingConfigSaga() {
  yield takeLatest(CLIENTS_EDIT.EDIT_ONB_CONFIG, editOnboardingConfig);
}

function* addOnboardingConfigSaga() {
  yield takeLatest(CLIENTS_EDIT.ADD_ONB_CONFIG, addOnboardingConfig);
}

function* enableRealTimeApiSaga() {
  yield takeLatest(CLIENTS_EDIT.ENABLE_REAL_TIME_API, enableRealTimeApi);
}

function* disableRealTimeApiSaga() {
  yield takeLatest(CLIENTS_EDIT.DISABLE_REAL_TIME_API, disableRealTimeApi);
}

export default [
  fetchOnboardingConfigsL1Saga(),
  fetchOnboardingConfigsL2Saga(),
  fetchOnboardingConfigsL3Saga(),
  fetchOnboardingConfigTypesSaga(),
  fetchClientOnboardingConfigSaga(),
  fetchClientSaga(),
  editClientSaga(),
  editOnboardingConfigSaga(),
  addOnboardingConfigSaga(),
  enableRealTimeApiSaga(),
  disableRealTimeApiSaga(),
];
